module.exports = __webpack_public_path__ + "img/d3.0167eea6.png";